// client/src/components/BidEstimation/VendorQuotes/CatalogMatchDropdown.js
import React, { useState, useEffect } from 'react'
import { TextField, MenuItem, ListItemText, Typography, Divider } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import axios from 'axios'

export default function CatalogMatchDropdown ({ value, onChange, lineItem }) {
  const [options, setOptions] = useState([])
  const [inputValue, setInputValue] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (inputValue.length < 2) {
      setOptions([])
      return
    }
    const timer = setTimeout(async () => {
      setLoading(true)
      try {
        const { data } = await axios.get('/api/bid-estimation/materials', {
          params: { search: inputValue }
        })
        setOptions(data)
      } catch (e) {
        console.error('Catalog search failed:', e)
      }
      setLoading(false)
    }, 300)
    return () => clearTimeout(timer)
  }, [inputValue])

  const handleCreateNew = async () => {
    const key = `${lineItem.description}||${lineItem.uom}`
    try {
      const { data } = await axios.post('/api/bid-estimation/materials', {
        description: lineItem.description,
        unit: lineItem.uom,
        key,
        category: 'general'
      })
      onChange(data._id, 'new_created')
    } catch (e) {
      // Handle duplicate key error — item already exists, find and use it
      if (e.response?.status === 500 && e.response?.data?.error?.includes('duplicate key')) {
        try {
          const { data } = await axios.get('/api/bid-estimation/materials', {
            params: { search: lineItem.description }
          })
          const existing = data.find(item => item.key === key)
          if (existing) {
            onChange(existing._id, 'mapped')
            return
          }
        } catch (searchErr) { /* fall through */ }
      }
      console.error('Create catalog item failed:', e)
    }
  }

  return (
    <Autocomplete
      size='small'
      options={options}
      loading={loading}
      getOptionLabel={(opt) => opt.description || ''}
      inputValue={inputValue}
      onInputChange={(e, val) => setInputValue(val)}
      onChange={(e, selected) => {
        if (selected) {
          onChange(selected._id, 'mapped')
        }
      }}
      renderOption={(opt) => (
        <ListItemText
          primary={opt.description}
          secondary={`${opt.unit} | Best: $${opt.bestPrice || '—'} | ${opt.vendorPrices?.length || 0} vendor prices`}
        />
      )}
      renderInput={(params) => (
        <TextField {...params} placeholder='Search catalog...' variant='outlined' size='small' />
      )}
      noOptionsText={
        inputValue.length >= 2 ? (
          <MenuItem onClick={handleCreateNew}>
            <Typography color='primary'>+ Create New Catalog Item</Typography>
          </MenuItem>
        ) : 'Type to search...'
      }
      style={{ minWidth: 250 }}
    />
  )
}
